import React from 'react';
import JobsRoutings from './JobsRoutings';

const Jobs = () => <JobsRoutings />;

export default Jobs;
